import './ColorCreateEdit.scss';

import React, { Component } from 'react';
import Logger from '@KrashidBuilt/common/utils/logger';
import PropTypes from 'prop-types';

import api from '../../../../api';
import { ColorGrid } from '../../../../components';
import { ROUTE_MAP } from '../../../../routes';

import { Colors, ButtonType, Orientation } from '@fifth-gear-tech/common-components/dist/utils/StyledTheme';
import {
    Button,
    FormSection,
    FormContainer,
    InputField,
} from '@fifth-gear-tech/common-components/dist/components';

const logger = new Logger('ColorCreateEdit');

/**
 * Parts Component
 * @augments {Component<Props, State>}
 */
class ColorCreateEdit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            entity: {
                id: 0,
                name: '',
                json_data: {
                    items: []
                }
            },
        };
    }

    load = () => {
        const { match: { params: { colorId } } } = this.props;
        this.setState({ loading: true }, async () => {
            const promises = [];

            promises.push(api.colors.getOne({ colorId }));

            const [_entity] = await Promise.all(promises.map((p) => p.catch((e) => {
                logger.error(e); return e;
            })));

            const entity = _entity instanceof Error ? this.state.entity : _entity;

            this.setState({
                loaded: true,
                loading: false,
                entity,
            });
        });
    }

    componentDidMount() {
        const { loaded } = this.state;
        if (!loaded) {
            this.load();
        }
    }

    onSave = async () => {
        const { entity: { id, name, json_data } } = this.state;

        const payload = { id, name, json_data };

        if (id) {
            await api.colors.updateOne(id, payload);
        } else {
            await api.colors.createOne(payload);
        }

        this.props.history.push(ROUTE_MAP.SETTINGS.COLORS);
    }

    onDelete = async () => {
        const { entity: { id } } = this.state;
        await api.colors.removeOne({ colorId: id });
        this.props.history.push(ROUTE_MAP.SETTINGS.COLORS);
    }

    setEntityField = (key, value) => {
        const { entity } = this.state;
        const cloned = JSON.parse(JSON.stringify(entity));
        cloned[key] = value;
        this.setState({ entity: cloned });
    }

    setEntityJsonField = (key, value) => {
        const { entity } = this.state;
        const cloned = JSON.parse(JSON.stringify(entity));
        cloned['json_data'][key] = value;
        this.setState({ entity: cloned });
    }

    isValid = () => {
        const { entity: { name, json_data: { items } } } = this.state;
        return name && items && items?.length >= 1;
    }

    render() {
        logger.extra({ _: this });
        const { entity: { id, name, json_data } } = this.state;

        const deleteButton = id >= 1 ? <Button key='delete' type={ButtonType.Delete} className={'danger'} label={'Delete'} onClick={this.onDelete} /> : null;


        return (
            <div className={'ColorCreateEdit'}>

                <FormContainer
                    title={''}
                    leftContent={
                        <Button
                            key={'return'}
                            type={ButtonType.Reset}
                            label={'Return'}
                            onClick={() => {
                                this.props.history.push(ROUTE_MAP.SETTINGS.COLORS);
                            }}
                        />
                    }
                    buttons={[
                        deleteButton,
                        <Button
                            key={'updateSave'}
                            type={id >= 1 ? ButtonType.Update : ButtonType.Save}
                            colorTheme={Colors.Green}
                            label={`${id >= 1 ? 'Update' : 'Create'}`}
                            onClick={this.onSave}
                            disabled={!this.isValid()}
                        />
                    ]}
                >
                    <FormSection
                        label={'Color Band Name'}
                        subtext={'Update or delete the current color band name'}
                        colorTheme={Colors.Grey}
                        orientation={Orientation.Horizontal}
                    >

                        <InputField
                            label={'Name'}
                            defaultValue={name}
                            onChange={(e) => {
                                this.setEntityField('name', e.target.value);
                            }}
                            clearIcon={true}
                            value={name}
                            onIconClick={() => this.setEntityField('name', '')}
                        />
                    </FormSection>
                    <FormSection
                        label={'Colors'}
                        subtext={'Update or delete the current color band colors'}
                        colorTheme={Colors.Grey}
                        orientation={Orientation.Mobile}
                    >
                        <ColorGrid grid={json_data} update={(v) => {
                            this.setEntityField('json_data', v);
                        }} />

                    </FormSection>
                </FormContainer>
            </div>
        );
    }
}

ColorCreateEdit.defaultProps = {
};

ColorCreateEdit.propTypes = {
    match: PropTypes.shape(),
    history: PropTypes.shape(),
};


export default ColorCreateEdit;